import type { ThemeConfig } from 'antd'

const DEFAULT_PRIMARY_COLOR = '#1890ff'
const DARK_LAYOUT_BG = '#000'

export const buildAppTheme = (primaryColor?: string): ThemeConfig => ({
  token: {
    colorPrimary: primaryColor || DEFAULT_PRIMARY_COLOR,
    colorLink: primaryColor || DEFAULT_PRIMARY_COLOR,
    colorError: '#ec5b5e',
    colorText: '#727374',
    colorTextHeading: '#000000',
    borderRadius: 4,
    zIndexPopupBase: 10001000,
    controlOutline: 'transparent'
  },
  components: {
    Layout: {
      headerBg: DARK_LAYOUT_BG,
      siderBg: DARK_LAYOUT_BG,
      triggerBg: DARK_LAYOUT_BG
    },
    Menu: {
      darkItemBg: DARK_LAYOUT_BG,
      darkSubMenuItemBg: DARK_LAYOUT_BG,
      darkPopupBg: DARK_LAYOUT_BG
    },
    Table: {
      rowSelectedBg: '#f5f5f5',
      rowSelectedHoverBg: '#f0f0f0'
    },
    Tabs: {
      horizontalItemGutter: 16
    },
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none'
    },
    Input: {
      activeShadow: 'none'
    }
  }
})
